/* ======== Components ========= */
import { useAppStore } from "@hooks/useAppStore";
import Box from "@memorang/ui/components/Box";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import ProductIcon from "components/ProductIcon";

export type ProductIconProps = {
	url?: string;
	numItems: number;
	selectedDate?: string;
	fromHomePage?: boolean;
};

const ProductIconContainer = ({
	url,
	selectedDate,
	fromHomePage,
}: ProductIconProps) => {
	const purchase = useAppStore((store) => store.app.purchase);

	const appFont = useAppStore((store) => store.app.font);

	const customSubheading = purchase?.paywall?.subtitle;

	const subHeadingTemplate = () => {
		if (customSubheading) {
			return customSubheading;
		}
		if (fromHomePage) {
			return "Purchase to unlock all items and maximize your test readiness";
		}

		return `**Unlock all items and maximize your test readiness**${
			selectedDate ? ` **before ${selectedDate}**` : ""
		}`;
	};
	const subheading = subHeadingTemplate();
	return (
		<>
			<Box alignItems="center">
				<ProductIcon enabledBoxShadow image={url || ""} size={128} />
			</Box>
			<CustomMarkdownRenderer
				text={subheading}
				variant="explanation"
				textAlign="center"
				appFont={appFont}
				fontSize={16}
			/>
		</>
	);
};

export default ProductIconContainer;
